import { DECLINE_DECISIONS } from '../../constants/decision';
/**
 * Check if the product has a declined reason
 *
 * @param {String} decision
 * @returns {Bool}
 */
export const isCoverDeclined = (decision) => {
  if (!decision) return false;
  return (
    DECLINE_DECISIONS.indexOf(decision.replace(/ /g, '').toLowerCase()) !== -1
  );
};

export const getBenefitAllocationsTotal = (benefitAllocations) =>
  benefitAllocations.reduce((acc, obj) => {
    return acc + obj.percent;
  }, 0);

export const isBenefitAllocationsValid = (benefitAllocations) => {
  if (!benefitAllocations || benefitAllocations.length <= 0) {
    return false;
  }
  return getBenefitAllocationsTotal(benefitAllocations) === 100;
};

export const isApplicantCoversBenefitAllocationsValid = (covers) =>
  covers.filter(
    (cover) =>
      cover.isPayoutPlannerUsed === true &&
      !isBenefitAllocationsValid(cover.benefitAllocations)
  ).length === 0;

export const filterApplicantQuoteCovers = (covers, quoteCovers) => {
  return covers.filter((cover) => {
    try {
      return (
        quoteCovers.findIndex(
          (quoteCover) =>
            quoteCover.id === cover.id && !isCoverDeclined(quoteCover.decision)
        ) !== -1
      );
    } catch {
      return true;
    }
  });
};

export const isApplicantsCoversBenefitAllocationsValid = (
  applicants,
  quoteApplicants
) =>
  applicants.filter(
    (applicant) =>
      !isApplicantCoversBenefitAllocationsValid(
        filterApplicantQuoteCovers(
          applicant.covers,
          quoteApplicants.find(
            (quoteApplicant) => quoteApplicant.id === applicant.id
          )?.quoteCovers
        )
      )
  ).length === 0;
